import { useNavigate } from "react-router-dom"
import styled from "styled-components"
import { Button } from "~/components"
import { useTranslate } from "~/ur-react-hooks"
import { useToast } from "~/utils"
import { useErrorHandling } from "~/utils/error"
import { useOrganizationMembership } from "~/utils/hooks/useOrganizationMembership"
import { trpc } from "~/utils/trpc"

const Layout = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 6rem;
`

const Card = styled.div`
  background: white;
  box-shadow: ${(props) => props.theme.shadow.elevation3};
  padding: 2rem;
  width: 456px;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 8px;
`

const ButtonWrapper = styled.div`
  position: relative;
`

const Asterix = styled.small`
  position: absolute;
  top: 1rem;
  right: 1rem;
  display: inline-block;
  margin-top: -8px;
`

const Discmalimer = styled.span`
  text-align: center;
  font-size: 12px;
  width: 300px;
  margin-top: 1rem;
`

export type SubscriptionSchoolNoSubscriptionProps = {}

const SubscriptionSchoolNoSubscription: React.FC<
  SubscriptionSchoolNoSubscriptionProps
> = () => {
  const organizationMembership = useOrganizationMembership()!

  const translations = useTranslate({
    title: "subscription-school.no-subscription.title",
    buttonText: "subscription-school.no-subscription.buttonText",
    disclaimer: [
      "subscription-school.no-subscription.disclaimer",
      { school: organizationMembership.organization.name },
    ],
    toastSuccess: "subscription-school.no-subscription.toast.success",
  })

  const toast = useToast()
  const navigate = useNavigate()
  const { getToastInfo } = useErrorHandling()

  const trpcContext = trpc.useContext()

  const { mutate: createNewSubscription, isLoading } =
    trpc.subscriptions.createOrganizationSubscription.useMutation({
      onSuccess() {
        toast("success", translations.toastSuccess)
        navigate("/home")
        trpcContext.subscriptions.getOrganizationSubscription.invalidate()
      },
      onError(error) {
        const { type, message } = getToastInfo(
          error.message,
          error.data?.code,
          "error",
        )
        toast(type, message)
      },
    })

  return (
    <Layout>
      <Card>
        <h4>{translations.title}</h4>
        <ButtonWrapper>
          <Button
            disabled={isLoading}
            onClick={() => {
              createNewSubscription(organizationMembership.organizationId)
            }}
          >
            {translations.buttonText} <Asterix>*</Asterix>
          </Button>
        </ButtonWrapper>
        <Discmalimer>{translations.disclaimer()}</Discmalimer>
      </Card>
    </Layout>
  )
}

export default SubscriptionSchoolNoSubscription
